import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const ShefHat = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG height={24} width={24} viewBox={'0 0 24 24'} {...props}>
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M16.3941 6.74868C16.753 6.65201 17.1294 6.60059 17.5172 6.60059C19.993 6.60059 22 8.69593 22 11.2807C22 13.7442 20.1769 15.7631 17.8624 15.9471V20.0001C17.8624 20.5524 17.4146 21.0001 16.8624 21.0001H7.13819C6.5859 21.0001 6.13819 20.5524 6.13819 20.0001V15.9471C3.82343 15.7634 2 13.7444 2 11.2807C2 8.69593 4.00701 6.60059 6.48277 6.60059C6.8707 6.60059 7.24712 6.65203 7.60611 6.74874C8.01973 4.6102 9.82981 3 12.0001 3C14.1704 3 15.9805 4.61017 16.3941 6.74868Z'
      fill='currentColor'
    />
  </SVG>
);
